import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faInfo } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'jalali-moment';

const MySwal = withReactContent(Swal);

export default class OpportunityTable extends Component {
  constructor() {
    super();
    this.state = {
      posts: [],
      search:''
    };
  }
  componentDidMount() {
    this.getPost();
    this.getUnreadResumes();
  }

  getUnreadResumes() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/show-new-resumejobopportunity')
      .then((res) => {
        console.log('Unread', res);
      })
      .catch((err) => {
        console.log('err Unread', err);
      });
  }
  deleteHandler(id) {
    axios
      .get(`https://arianaapp.arianaapply.com/panel/job-opportunity-delete/${id}`)
      .then((res) => {
        console.log(res);

        Swal.fire({
          title: 'با موفقیت حذف شد',
          icon: 'success',
        }).then((res) => {
          window.location.reload();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className='index'>
        {this.state.posts.length > 0 ? (
          <div className='table'>
            <div style={{width:'100%', display:'flex', justifyContent:'center', margin:'1rem 0'}}>
              <input
                className='search-input'
                type='search'
                name='search'
                value={this.state.search}
                placeholder='جستجو کنید....'
                onChange={(e) => this.setState({search: e.target.value})}
              />
            </div>
            <table>
              <thead>
                <tr>
                  <td>#</td>
                  <td>عنوان</td>
                  <td>شهر</td>
                  <td>کشور</td>
                  <td>دسته</td>
                  <td>شرکت</td>
                  <td>تاریخ</td>
                  <td>عملیات</td>
                  <td>رزومه </td>
                </tr>
              </thead>
              <tbody>
                {this.state.posts.filter((p => p.title.toLowerCase().includes(this.state.search))).reverse().map((item, i) => (
                  <tr key={item._id}>
                    <td>{i}</td>
                    <td>{item.title}</td>
                    <td>{item.city}</td>
                    <td>{item.country}</td>
                    <td>{item.type}</td>
                    <td>{item.company}</td>
                    <td>
                      {(() => {
    try {
      return item.created_at
        ? moment(item.created_at).locale('fa').format('YYYY/MM/DD')
        : '-';
    } catch (e) {
      return '-';
    }
  })()}
                      </td>
                    <td>
                      <div className='d-flex'>
                        <Link to={`/opportunity-edit/${item._id}`}>
                          <button className='success'>
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </Link>
                        <button
                          className='danger'
                          onClick={() => this.deleteHandler(item._id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                    <td>
                      <Link to={`/job-resume/${item._id}`}>
                        <button className='info'>
                          <FontAwesomeIcon icon={faInfo} />
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <Spinner animation='border' variant='primary' />
        )}
      </div>
    );
  }

  getPost() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/job-opportunity-list')
      .then((response) => {
        this.setState({ posts: response.data.data });
        console.log(response);
      })
      .catch((err) => {
        console.log(err.response);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }
}
